import React from 'react';
import { StyledFooter, StyledFooterInnerContainer, StyledFooterCopyright, Container } from './styles';

export const Footer = () => {
  return (
    <StyledFooter>
      <Container>
        <StyledFooterInnerContainer>
          <StyledFooterCopyright>
            <span>Breathe Software Pty Ltd ABN 27 643 981 579</span>
            <span>© Copyright {new Date().getFullYear()} Breathe Software Pty Ltd, all rights reserved</span>
          </StyledFooterCopyright>
        </StyledFooterInnerContainer>
      </Container>
    </StyledFooter>
  );
};
